import React from 'react';
import { useAddressFormPresenter } from './AddressForm.presenter';

import { realtyStateOwn } from 'store/anketa/mappers/livingAddressProperty';
import { InputMask } from 'utils/inputMask';
import { VOID_FUNCTION } from 'constants';
import { ADDRESS_FORM_LABELS, NAMES } from './AddressForm.constants';
import { KEY_COMPONENTS } from 'components/modules/MainAnketa/MainAnketa.constants';

import { CheckSvg, AlertSvg } from 'assets/img';
import { AnketaChevronStyled, ReactTooltipStyled, AreaInfo } from '../../../MainAnketa.styles';
import { FormSubheader } from '../../AnketaForm.styles';
import * as S from './AddressForm.styles';

export const AddressForm = ({
  persona,
  validate,
  errors,
  confidenceErrors,
  clearConfidenceErrors,
  disabled = false,
  setFocusAt,
  onChange = VOID_FUNCTION,
}) => {
  const presenter = useAddressFormPresenter({
    persona,
    validate,
    errors,
    confidenceErrors,
    clearConfidenceErrors,
    setFocusAt,
    onChange,
  });

  const { addressFormValues, addressLiveFormValues, livingAddressPropFormValues } = presenter;

  if (!addressFormValues) {
    return null;
  }

  return (
    <S.FormGridRow id={KEY_COMPONENTS.ADDRESS_REG}>
      <S.FormHeader
        collapsed={!presenter.showMore}
        data-test={`${KEY_COMPONENTS.ADDRESS_REG} ${
          !presenter.showMore ? 'collapsed' : 'expanded'
        }`}
        onClick={presenter.onHeaderClick}
      >
        <AnketaChevronStyled className="chevron" />
        <h3>Адрес регистрации</h3>

        {!disabled && (
          <AreaInfo>
            {presenter.shouldShowCheckIcon ? (
              <>
                <CheckSvg className="check" data-tip="" data-for="addressCheckInfo" />
                <ReactTooltipStyled id="addressCheckInfo" place="right">
                  <span>Распознан</span>
                </ReactTooltipStyled>
              </>
            ) : presenter.shouldShowAlertIcon ? (
              <>
                <AlertSvg className="alert" data-tip="" data-for="addressAlertInfo" />
                <ReactTooltipStyled id="addressAlertInfo" place="right">
                  <span>Загрузите документ</span>
                </ReactTooltipStyled>
              </>
            ) : null}
          </AreaInfo>
        )}
      </S.FormHeader>

      {presenter.showMore && (
        <>
          <S.Address
            id={`${KEY_COMPONENTS.ADDRESS_REG}_${NAMES.FIAS_VALUE}`}
            tabIndex="20"
            label={ADDRESS_FORM_LABELS[NAMES.FIAS_VALUE]}
            type="address"
            defaultValue={addressFormValues[NAMES.FIAS_VALUE]}
            error={presenter.getError(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.FIAS_VALUE}`)}
            confidenceError={
              addressFormValues[NAMES.FIAS_VALUE] &&
              presenter.getConfidenceError(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.FIAS_VALUE}`)
            }
            required
            disabled={disabled}
            onChange={presenter.changeHandlerAddress}
            onBlur={() => presenter.validation(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.FIAS_VALUE}`)}
          />

          {presenter.shouldShowIndex && (
            <S.Index
              id={`${KEY_COMPONENTS.ADDRESS_REG}_${NAMES.INDEX}`}
              tabIndex="22"
              label={ADDRESS_FORM_LABELS[NAMES.INDEX]}
              type="address"
              defaultValue={addressFormValues[NAMES.INDEX]}
              val={addressFormValues[NAMES.INDEX]}
              error={presenter.getError(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.INDEX}`)}
              mask={InputMask.INDEX}
              unmask
              required
              disabled={disabled}
              onChange={presenter.changeHandlerIndex}
              onBlur={() => presenter.validation(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.INDEX}`)}
            />
          )}

          <S.RegistrationDate
            id={`${KEY_COMPONENTS.ADDRESS_REG}_${NAMES.REGISTRATION_DATE}`}
            tabIndex="21"
            label={ADDRESS_FORM_LABELS[NAMES.REGISTRATION_DATE]}
            name={NAMES.REGISTRATION_DATE}
            defaultValue={addressFormValues[NAMES.REGISTRATION_DATE]}
            val={addressFormValues[NAMES.REGISTRATION_DATE]}
            error={presenter.getError(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.REGISTRATION_DATE}`)}
            confidenceError={
              addressFormValues[NAMES.REGISTRATION_DATE] &&
              presenter.getConfidenceError(
                `${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.REGISTRATION_DATE}`
              )
            }
            mask={InputMask.DATE_BEFORE_TODAY}
            unmask
            required
            disabled={disabled}
            dataTest="registrationDate"
            onChange={presenter.changeHandlerRegistrationDate}
            onBlur={() =>
              presenter.validation(`${KEY_COMPONENTS.ADDRESS_REG}.${NAMES.REGISTRATION_DATE}`)
            }
          />

          {!addressFormValues.livingAddressEquals && (
            <>
              <FormSubheader style={{ marginTop: '0' }}>Адрес проживания</FormSubheader>
              <S.AddressLive
                id={`${KEY_COMPONENTS.ADDRESS_LIVE}_${NAMES.FIAS_VALUE}`}
                tabIndex="23"
                label={ADDRESS_FORM_LABELS[NAMES.FIAS_VALUE]}
                type="address"
                defaultValue={addressLiveFormValues?.[NAMES.FIAS_VALUE]}
                error={presenter.getError(`${KEY_COMPONENTS.ADDRESS_LIVE}.${NAMES.FIAS_VALUE}`)}
                required
                disabled={disabled}
                onChange={presenter.onHandleAddressLive}
                onBlur={() =>
                  presenter.validation(`${KEY_COMPONENTS.ADDRESS_LIVE}.${NAMES.FIAS_VALUE}`)
                }
              />

              {presenter.shouldShowIndexLive && (
                <S.IndexLive
                  id={`${KEY_COMPONENTS.ADDRESS_LIVE}_${NAMES.INDEX}`}
                  tabIndex="24"
                  label={ADDRESS_FORM_LABELS[NAMES.INDEX]}
                  type="address"
                  defaultValue={addressLiveFormValues[NAMES.INDEX]}
                  val={addressLiveFormValues[NAMES.INDEX]}
                  error={presenter.getError(`${KEY_COMPONENTS.ADDRESS_LIVE}.${NAMES.INDEX}`)}
                  mask={InputMask.INDEX}
                  unmask
                  required
                  disabled={disabled}
                  onChange={presenter.changeHandlerIndexLive}
                  onBlur={() =>
                    presenter.validation(`${KEY_COMPONENTS.ADDRESS_LIVE}.${NAMES.INDEX}`)
                  }
                />
              )}
            </>
          )}
        </>
      )}

      <S.LivingAddressEqualsToogle
        name={NAMES.LIVING_ADDRESS_EQUALS}
        value={addressFormValues[NAMES.LIVING_ADDRESS_EQUALS]}
        disabled={disabled}
        dataTest="livingAddressEquals"
        onChange={presenter.changeHandlerLivingAddressEquals}
      >
        {ADDRESS_FORM_LABELS[NAMES.LIVING_ADDRESS_EQUALS]}
      </S.LivingAddressEqualsToogle>
      <S.RealtyStateToogle
        name={NAMES.REALTY_STATE}
        value={livingAddressPropFormValues[NAMES.REALTY_STATE]?.id === realtyStateOwn.id}
        disabled={disabled}
        dataTest="realtyState"
        onChange={presenter.onHandleLivingAddressProp}
      >
        {ADDRESS_FORM_LABELS[NAMES.REALTY_STATE]}
      </S.RealtyStateToogle>
    </S.FormGridRow>
  );
};
